module.exports = __webpack_public_path__ + "static/media/combat(5).c0c342e7.PNG";